<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (showCriticalError) {
    <div id="critical-error">
        <div class="error-header">{{ criticalError.header }}</div>
        <span class="error-text" (click)="reloadPage()">{{ criticalError.text }}</span>
    </div>
}
